module.exports = __webpack_public_path__ + "img/create_groups.86f8471f.png";